var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95842 7.48633L12.0209 0.423828C12.1876 0.257161 12.3855 0.173828 12.6147 0.173828C12.8438 0.173828 13.0418 0.257161 13.2084 0.423828C13.3751 0.590495 13.4584 0.788411 13.4584 1.01758C13.4584 1.24674 13.3751 1.44466 13.2084 1.61133L5.54176 9.278C5.37509 9.44466 5.18065 9.528 4.95842 9.528C4.7362 9.528 4.54176 9.44466 4.37509 9.278L0.791758 5.69466C0.625091 5.52799 0.54523 5.33008 0.552174 5.10091C0.559119 4.87174 0.645925 4.67383 0.812591 4.50716C0.979258 4.3405 1.17717 4.25716 1.40634 4.25716C1.63551 4.25716 1.83342 4.3405 2.00009 4.50716L4.95842 7.48633Z",
    fill: "#74A766"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.ec65b8598ff7249d4102325fe01f297b.svg";
export { ForwardRef as ReactComponent };